import React from 'react';
import styles from './css/NotFound.styl';

/**
 * NotFoundPage Module
 * @class NotFoundPage
 */
export default class NotFoundPage extends React.Component {
  static contextTypes = {
    flux: React.PropTypes.object.isRequired,
  };

  /**
   * Constructor
   * @param  {Object} props   Passed in props
   * @param  {Object} context Flux context
   * @return {Undefined} Returns nothing
   */
  constructor(props, context) {
    super(props, context);
  }

  /**
   * Render Component
   * @return {JSX} Rendered NotFoundPage Component
   */
  render() {
    return (
      <div className={styles.NotFound}>
        <div className={styles.content}>
          <h1>Page Not Found</h1>
          <p>Sorry, but the page you were trying to view does not exist.</p>
          <a className={styles.button} href="/">
            Go To Home Page
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/NotFound/NotFound.js